import React from 'react';

import { useHistory } from 'react-router';

import routes from 'constants/routes';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import useBellAlerts from 'hooks/useBellAlerts';
import { NotificationIcon } from 'styles/assets/icons';

import styles from './bellAlerts.module.scss';

const BellAlertsIcon = () => {
  const { isNewBellAlerts, setIsNewBellAlerts } = useBellAlerts();
  const history = useHistory();

  const onBellAlertsClick = () => {
    trackMixpanelEvent('Bell Alerts Clicked');
    setIsNewBellAlerts(false);
    history.push(routes.bell_alerts);
  };

  return (
    (<div
      data-testid="notification-menu"
      aria-hidden="true"
      className={styles['notif-menu']}
      onClick={onBellAlertsClick}
      data-palette="BellAlertsIcon">
      <NotificationIcon width={18} height={18} />
      {isNewBellAlerts && (
        <span className={styles['notification-counter']} data-palette="BellAlertsIcon">
          <div className={styles.redDot} />
          {/* <NewBatch /> */}
        </span>
      )}
    </div>)
  );
};

export default BellAlertsIcon;
